import React from "react";

export default function Footer() {
  return (
    <footer className="bg-gray-100 text-center fixed bottom-0 py-4 w-full border-t border-gray-200 z-[400]">
      <p className="text-sm text-gray-600">
        Powered by <span className="font-semibold text-gray-800">Roamtech</span>{" "}
        |{" "}
        <a
          href="/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue hover:underline"
        >
          Privacy Policy
        </a>{" "}
        |{" "}
        <a
          href="/terms-and-conditions"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue hover:underline"
        >
          Terms and Conditions
        </a>
        |{" "}
        {!import.meta.env.PROD && (
          <span className="text-blue hover:underline">
            {/* eslint-disable-next-line no-undef */}
            Build: {__BUILD_DATE__}
          </span>
        )}
      </p>
    </footer>
  );
}
